import { useState, useEffect } from 'react';
import api from '../lib/api';
import { ShieldCheck, Leaf, Heart } from 'lucide-react';

const ICONS = { ShieldCheck, Leaf, Heart };

export default function MissionPage() {
  const [content, setContent] = useState(null);
  useEffect(() => { api.get('/settings/mission').then(r => setContent(r.data)).catch(() => {}); }, []);
  if (!content) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full" /></div>;

  return (
    <div data-testid="mission-page">
      {content.hero_image && (
        <div className="relative h-72 sm:h-96">
          <img src={content.hero_image} alt="" className="w-full h-full object-cover" />
          <div className="hero-overlay absolute inset-0" />
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-medium text-white tracking-tight">{content.heading || 'Our Mission'}</h1>
          </div>
        </div>
      )}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <p className="text-lg text-muted-foreground leading-relaxed whitespace-pre-line mb-12">{content.content}</p>
        {content.values?.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {content.values.map((v, i) => {
              const Icon = [ShieldCheck, Leaf, Heart][i % 3];
              return (
                <div key={i} className="text-center p-6 bg-card rounded-3xl border border-border/50">
                  <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-secondary mb-4">
                    <Icon className="h-6 w-6 text-primary" />
                  </div>
                  <h3 className="font-serif font-medium text-base mb-2">{v.title}</h3>
                  <p className="text-sm text-muted-foreground">{v.description}</p>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
